<template>
  <bk-view class="productImageWrap">
    <bk-title>{{ title }}</bk-title>
<!--    <bk-view class="arrow-left" @click="handlePre">-->
<!--      <svg class="slideshow-arrow" width="25px" height="42px" viewBox="0 0 25 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scaleX(-1) scale(0.92); fill: rgb(0, 0, 0);"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Artboard-Copy-97" transform="translate(-36.000000, -27.000000)" fill-rule="nonzero"><path d="M37.2206398,28.239114 C38.8026583,26.647265 41.3436172,26.5881667 42.9967317,28.0675785 L43.1590153,28.2206482 L59.1611748,44.1233571 C61.1319602,46.0819718 61.1995454,49.2312919 59.3527322,51.2754674 L59.1795659,51.4581932 L43.1590166,67.3793505 C41.51408,69.0140701 38.8553922,69.0057967 37.2206146,67.3608606 C35.638653,65.7689547 35.5953873,63.2276769 37.0850712,61.5838107 L37.2391492,61.4224839 L50.946,47.799 L37.2391492,34.1775161 C35.7003375,32.6482622 35.5938031,30.2229032 36.9247365,28.5696317 L37.0675472,28.4014262 L37.2206398,28.239114 Z" id="8"></path></g></g></svg>-->
<!--    </bk-view>-->
    <bk-view class="marquee-container">
      <bk-view
        class="marquee"
        ref="marqueeRef"
        @touchstart="handleTouchStart"
        @touchmove="handleTouchMove"
        @touchend="handleTouchEnd"
      >
        <img style="height: 150px;width: 150px" v-for="(item, index) in dataList" :key="index" :src="item.url"/>
      </bk-view>
    </bk-view>
<!--    <bk-view class="arrow-right" @click="handleNext">-->
<!--      <svg class="slideshow-arrow" width="25px" height="42px" viewBox="0 0 25 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="transform: scaleX(1) scale(0.92); fill: rgb(0, 0, 0);"><g id="Page-1" stroke="none" stroke-width="1" fill-rule="evenodd"><g id="Artboard-Copy-97" transform="translate(-36.000000, -27.000000)" fill-rule="nonzero"><path d="M37.2206398,28.239114 C38.8026583,26.647265 41.3436172,26.5881667 42.9967317,28.0675785 L43.1590153,28.2206482 L59.1611748,44.1233571 C61.1319602,46.0819718 61.1995454,49.2312919 59.3527322,51.2754674 L59.1795659,51.4581932 L43.1590166,67.3793505 C41.51408,69.0140701 38.8553922,69.0057967 37.2206146,67.3608606 C35.638653,65.7689547 35.5953873,63.2276769 37.0850712,61.5838107 L37.2391492,61.4224839 L50.946,47.799 L37.2391492,34.1775161 C35.7003375,32.6482622 35.5938031,30.2229032 36.9247365,28.5696317 L37.0675472,28.4014262 L37.2206398,28.239114 Z" id="8"></path></g></g></svg>-->
<!--    </bk-view>-->
  </bk-view>
</template>

<script>

	export default {
		name: 'productImageWrap',
		props: {
			title: String,
			dataList: {
				type: Array, default: () => {
					return [];
				}
			},
		},
		data () {
			return {
				dragging: false
			};
		},
		computed: {},
		watch: {},
		methods: {
			handleTouchStart () {
				// this.dragging = true;
			},
			handleTouchMove (event) {
				// if (!this.dragging) {
				// 	return;
				// }
			},
			handleTouchEnd () {
				// this.dragging = false;
			},

			handlePre () {
			},
			handleNext () {
			}
		}
	};
</script>

<style scoped lang="less">
@import './productImageWrap.less';
</style>